<template>
    <!-- Shipping Tracking -->
			<modal
            class="tracking-modal"
            size="large"
            @close="hideShippingTracking"
            v-if="isShowShippingTracking && selectedSubmission"
        >
            <div slot="header">
                <h3>
                    <b>Lacak</b>
                </h3>
            </div>
            <div slot="body">
                <div class="css-1k344vm__content tracking-more-height">
                    <div class="css-13ap7lc">
                        <div class="css-jiyk74">
                            <div class="css-1et7y05">
                                <div class="css-2vkss2">
                                    <div class="title">Kurir:</div>
                                    <div class="text text-uppercase">{{ selectedSubmission.shipping.courier }}</div>
                                </div>
                                <div class="css-2vkss2">
                                    <div class="title">Layanan:</div>
                                    <div class="text text-uppercase">{{ selectedSubmission.shipping.service }}</div>
                                </div>
                            </div>
                            <div class="css-bys9cl">
                                <div class="css-1hmvpdg">
                                    <div class="css-7dif1t">
                                        <div class="title">Nomor resi</div>
                                        <div class="text text--resi">{{ selectedSubmission.shipping.receipt_number }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="css-mup5jr">
                            <img
                                src="https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/3a90d3a1.png"
                                alt=""
                            />
                            <div class="status-shipping-wrapper mt-3">
                                Status: <b class="text-capitalize">{{ selectedSubmission.shipping.delivery_status }}</b>
                            </div>
                            <section
                                class="timeline-wrapper css-14fpj81-unf-card eyk31ek0"
                            >
                                <shipment-tracking
                                    v-for="(history, index) in histories"
                                    :key="index"
                                    :history="history"
                                    :courier="selectedSubmission.shipping.courier"
                                >
                                </shipment-tracking>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button class="btn btn-light" @click="hideShippingTracking">
                    {{ $t('Close') }}
                </button>
            </div>
        </modal>
</template>
<script>
import {
	duplicateVar,
} from '@/lib/helper';
import ShipmentTracking from '@/components/ShipmentTracking.vue';
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalShipmentTracking',
	props: {
		selectedSubmission: {
			type: Object,
			default() {},
		},
		isShowShippingTracking: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ShipmentTracking,
		Modal,
	},
	data() {
		return {
			orders: [],
			// isShowShippingTracking: false,
		};
	},
	computed: {
		histories() {
			return this.selectedSubmission.shipping.trackings && this.selectedSubmission.shipping.trackings.history ? duplicateVar(this.selectedSubmission.shipping.trackings.history).reverse() : [];
		},
	},
	methods: {
		hideShippingTracking() {
			this.$emit('hide');
			// this.isShowShippingTracking = false;
			// this.selectedSubmission = {};
		},
	},

};
</script>
